const fromdatainv = [
  {
    inputdata: "",
    title: "经销商单据号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "input",
    width: "180px",
    lablewith: "100px",
    btx: true,
  },
  {
    inputdata: "",
    title: "产品线",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "select",
    width: "190px",
    options: [],
    event: "invClass",
    btx: true,
    lablewith: "60px",
  },
  {
    inputdata: "",
    title: "出库日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "",
    inputtype: "date",
    width: "180px",
    widths: "200px",
    lablewith: "60px",
    btx: true,
  },
  {
    inputdata: 1,
    title: "状态",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "select",
    width: "190px",
    options: [
      {
        key: 1,
        value: "审核"
      }
    ],
    btx: true,
    lablewith: "100px",
  },
  {
    inputdata: "",
    title: "付款方",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "selectautocompletes",
    btx: true,
    width: "190px",
    options: [],
    lablewith: "60px",
  },
  {
    inputdata: "",
    title: "审核日期",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "date",
    width: "180px",
    widths: "200px",
    lablewith: "60px",
    btx: true,
  },
  {
    inputdata: 1,
    title: "单据类型",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请选择",
    types: "",
    inputtype: "select",
    width: "190px",
    lablewith: "100px",
    options: [
      {
        key: 1,
        value: "销售订单"
      },
      {
        key: 2,
        value: "销售退货单" 
      }
    ],
  },
  {
    inputdata: "",
    title: "产品型号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "180px",
    lablewith: "60px",
  },
  {
    inputdata: "",
    title: "产品名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "300px",
    lablewith: "65px",
  },
  {
    inputdata: "",
    title: "批号",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "180px",
    lablewith: "100px",
  },
  {
    inputdata: "",
    title: "出库单",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "180px",
    lablewith: "60px",
  },
];
export default fromdatainv;
